import React from 'react'
import DataLoader from '../data/DataLoader'
import Footer from '../footer/Footer'
import Testimonials from '../testimonials/Testimonials'
import {withRouter} from 'react-router-dom'
import MetaTags from 'react-meta-tags'

class AboutPage extends React.Component {
  render () {


    let content = this.props.content


    //console.log("About Page",content);


    return(
      <div className="standard-page about-page" ref="container">

        <MetaTags>
          <meta id="meta-description" name="description" content={content.acf.meta_description} />
          <title>{'The Fyzz - Facility'}</title>
          <meta id="og-title" property="og:title" content={'The Fyzz - Facility | '+content.title.rendered} />
        </MetaTags>

        <section className="header content-row">
          <div className="inner">
            <h1 className="page-title" dangerouslySetInnerHTML={{__html:content.title.rendered}}></h1>
            <div className="intro" dangerouslySetInnerHTML={{__html:content.content.rendered}}></div>
          </div>
        </section>

        <section className="header about-section content-row">
          <div className="inner">
            <h1 className="page-title" dangerouslySetInnerHTML={{__html:content.acf.second_title}}></h1>
            <div className="intro">

            <div className="charts">

                {content.acf.chart_1.number ?
                    <div className="chart">
                      <svg width="122" height="122">
                        <circle cx="61" cy="59" r="58" transform="rotate(60, 60, 60)"/>
                      </svg>
                        <div className="number" dangerouslySetInnerHTML={{__html:content.acf.chart_1.number}}></div>
                        <div className="caption" dangerouslySetInnerHTML={{__html:content.acf.chart_1.caption}}></div>
                    </div>
                : null }

                {content.acf.chart_2.number ?

                  <div className="chart">
                    <svg width="122" height="122">
                      <circle cx="61" cy="59" r="58" transform="rotate(60, 60, 60)"/>
                    </svg>
                      <div className="number" dangerouslySetInnerHTML={{__html:content.acf.chart_2.number}}></div>
                      <div className="caption" dangerouslySetInnerHTML={{__html:content.acf.chart_2.caption}}></div>
                  </div>
                : null }

                {content.acf.chart_3.number ?

                  <div className="chart">
                    <svg width="122" height="122">
                      <circle cx="61" cy="59" r="58" transform="rotate(60, 60, 60)"/>
                    </svg>
                      <div className="number" dangerouslySetInnerHTML={{__html:content.acf.chart_3.number}}></div>
                      <div className="caption" dangerouslySetInnerHTML={{__html:content.acf.chart_3.caption}}></div>
                  </div>

                :null }


                {content.acf.chart_4.number ?
                  <div className="chart">
                    <svg width="122" height="122">
                      <circle cx="61" cy="59" r="58" transform="rotate(60, 60, 60)"/>
                    </svg>
                      <div className="number" dangerouslySetInnerHTML={{__html:content.acf.chart_4.number}}></div>
                      <div className="caption" dangerouslySetInnerHTML={{__html:content.acf.chart_4.caption}}></div>
                  </div>
                : null }



            </div>


            <div dangerouslySetInnerHTML={{__html:content.acf.second_text}}>

            </div>



            </div>
          </div>
        </section>

        <section className="header about-section content-row testimonials-sections">
          <div className="inner">
            <h1 className="page-title">What people say about us</h1>
            <div className="intro">

                <Testimonials> </Testimonials>

            </div>
            </div>
          </section>


      <Footer></Footer>
      </div>
    )

  }
}

export default withRouter(AboutPage);



// WEBPACK FOOTER //
// ./src/modules/pages/AboutPage.js